<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <el-dialog
      title="查看图片"
      :visible.sync="img_pre"
      width="600px"
    >
      <div style="
          width: 100%;
          text-align: center;
          padding: 20px;
          box-sizing: border-box;
        ">
        <img
          :src="imgPre"
          alt
          style="width: 550px"
        />
      </div>
    </el-dialog>
    <!-- 病情自述弹窗 -->
    <el-dialog
      title="病情自述"
      :visible.sync="bingqing"
      width="820px"
      :close-on-click-modal="false"
    >
      <!-- 图片弹窗 -->
      <el-dialog
        title="图片查看"
        :visible.sync="img_pre"
        width="700px"
        append-to-body
      >
        <div style="width: 100%; text-align: center">
          <img
            :src="imgPre"
            alt
            style="width: 600px"
          />
        </div>
      </el-dialog>
      <div style="text-align: left; padding: 20px">
        <div class="littletitle">患者信息</div>
        <div style="margin: 8px 0 12px">
          <span>{{ bingqing_info.real_name }}</span>
          <span
            style="margin: 0 40px"
            v-if="bingqing_info.sex == 1"
          >男</span>
          <span
            style="margin: 0 40px"
            v-if="bingqing_info.sex == 2"
          >女</span>
          <span
            style="margin: 0 40px"
            v-if="bingqing_info.sex == 0"
          >未知</span>
          <span>{{ bingqing_info.age }}</span>
        </div>
        <div>
          <span class="gray">科室：</span>
          <span>{{ bingqing_info.department_name }}</span>
        </div>
        <div style="margin: 12px 0">
          <span class="gray">既往病史：</span>
          <span>{{ bingqing_info.history_name }}</span>
        </div>
        <div>
          <span class="gray">过敏史：</span>
          <span>{{ bingqing_info.allergen_name }}</span>
        </div>
        <div
          class="littletitle"
          style="margin: 20px 0 8px"
        >病情自述</div>
        <div>{{ bingqing_info.desc }}</div>
        <div
          class="littletitle"
          style="margin: 20px 0 8px"
        >舌苔、舌底照片</div>
        <div v-if="bingqing_info.tongue_img.length">
          <img
            :src="item"
            alt
            style="width: 120px; hight: 120px"
            v-for="(item, index) in bingqing_info.tongue_img"
            :key="index"
            class="myimg"
            @click="toimgPre(item)"
          />
        </div>
        <div v-else>未上传</div>
        <div
          class="littletitle"
          style="margin: 20px 0 8px"
        >面部、患处照片</div>
        <div v-if="bingqing_info.face_img.length">
          <img
            :src="item"
            alt
            style="width: 120px; hight: 120px"
            v-for="(item, index) in bingqing_info.face_img"
            :key="index"
            class="myimg"
            @click="toimgPre(item)"
          />
        </div>
        <div v-else>未上传</div>
        <div
          class="littletitle"
          style="margin: 20px 0 8px"
        >
          实体医疗机构病历
        </div>
        <div v-if="bingqing_info.history_img.length">
          <img
            :src="item"
            alt
            style="width: 120px; hight: 120px"
            v-for="(item, index) in bingqing_info.history_img"
            :key="index"
            class="myimg"
            @click="toimgPre(item)"
          />
        </div>
        <div v-else>未上传</div>
      </div>
    </el-dialog>
    <!-- 问诊单弹窗 -->
    <el-dialog
      title="问诊单"
      :visible.sync="wenzhendan"
      width="800px"
      :close-on-click-modal="false"
    >
      <div style="text-align: left; padding: 20px">
        <!-- wenzhen_info -->
        <div
          v-for="(item, index) in wenzhen_info"
          :key="index"
          style="margin-bottom: 20px"
        >
          <div class="wenzhentitle">
            <span>{{ index + 1 }}.{{ item.title }}</span>
            <span v-if="item.item_type == 1">（单选）</span>
            <span v-if="item.item_type == 2">（多选）</span>
            <span v-if="item.item_type == 3">（问答题）</span>
          </div>
          <div class="wenzhencontent">{{ item.content }}</div>
        </div>
      </div>
    </el-dialog>
    <!-- 处方建议 -->
    <el-dialog
      title="处方建议"
      :visible.sync="chufang"
      width="820px"
      :close-on-click-modal="false"
    >
      <!-- 图片弹窗 -->
      <el-dialog
        title="图片查看"
        :visible.sync="img_pre"
        width="820px"
        append-to-body
      >
        <div style="width: 100%; text-align: center">
          <img
            :src="imgPre"
            alt
            style="width: 700px"
          />
        </div>
      </el-dialog>
      <div class="chufangdia">
        <div class="inbobox">
          <div class="inboitem">
            <div>
              <span class="infotitle">用户昵称：</span>
              <span>{{ chufang_info.nick_name }}</span>
            </div>
            <div style="margin: 12px 0">
              <span class="infotitle">性别：</span>
              <span v-if="chufang_info.user_sex == 1">男</span>
              <span v-if="chufang_info.user_sex == 2">女</span>
              <span v-if="chufang_info.user_sex == 0">未知</span>
            </div>
            <div>
              <span class="infotitle">手机号：</span>
              <span>{{ chufang_info.user_phone }}</span>
            </div>
          </div>
          <div class="inboitem">
            <div style="display: flex">
              <div>
                <span class="infotitle">医生姓名：</span>
                <span>{{ chufang_info.doctor_name }}</span>
              </div>
              <div style="margin: 0 50px">
                <span>性别：</span>
                <span v-if="chufang_info.doctor_sex == 1">男</span>
                <span v-if="chufang_info.doctor_sex == 2">女</span>
              </div>
              <div>
                <span>手机号：</span>
                <span>{{ chufang_info.doctor_phone }}</span>
              </div>
            </div>
            <div style="margin: 12px 0">
              <span class="infotitle">职称：</span>
              <span>{{ chufang_info.title }}</span>
            </div>
            <div>
              <span class="infotitle">科室：</span>
              <span>{{ chufang_info.department_name }}</span>
            </div>
          </div>
        </div>
        <div class="dorder-divider">
          <span>
            <span>开方时间：</span>
            <span>{{ chufang_info.create_time }}</span>
          </span>
          <span style="margin: 0 50px">
            <span>处方状态：</span>
            <span>
              <span v-if="chufang_info.status == 1">待取药</span>
              <span v-if="chufang_info.status == 2">待审方</span>
              <span v-if="chufang_info.status == 3">已通过</span>
              <span v-if="chufang_info.status == 4">已抓药</span>
              <span v-if="chufang_info.status == 5">过期未取药</span>
              <span v-if="chufang_info.status == 6">审方不通过</span>
              <span v-if="chufang_info.status == 7">医生作废</span>
              <span v-if="chufang_info.status == 8">平台退款</span>
            </span>
          </span>
          <span>
            <span>处方号：</span>
            <span>{{ chufang_info.pre_id }}</span>
          </span>
          <el-button
            type="text"
            style="margin-left: 50px; font-size: 15px"
            @click="toimgPre(chufang_info.pre_img)"
          >原始处方 ></el-button>
        </div>
        <!-- 诊断 -->
        <div
          class="dorder-divider"
          style="padding-bottom:10px"
        >
          <div class="title">诊断</div>
          <div>
            <div>
              <span>
                <span>患者：</span>
                <span>{{ chufang_info.user_name }}</span>
                <span style="margin: 0 40px">{{
                  chufang_info.patient_sex == 1 ? '男' : '女'
                }}</span>
                <span>{{ chufang_info.age }}</span>
              </span>
              <span
                style="margin-left: 30px"
                v-if="chufang_info.patient_phone"
              >
                <span>手机号：</span>
                <span>{{ chufang_info.patient_phone }}</span>
              </span>
            </div>
            <div style="margin: 14px 0">
              <span>主诉：</span>
              <span>{{ chufang_info.chief_complaint }}</span>
            </div>
            <div>
              <span>诊断：</span>
              <span>{{ chufang_info.diagnosis }}</span>
            </div>
          </div>
        </div>
        <!-- 开方 -->
        <div
          class="dorder-divider"
          style="padding-bottom:10px"
        >
          <div class="flex-box">
            <p class="title">开方</p>
            <p class="pre-group">{{ chufang_info.drug_type_name }}</p>
          </div>
          <div class="title rp">Rp：</div>
          <!-- 中药材(颗粒 饮片 膏方 丸剂) -->
          <div
            class="itembox"
            v-if="chufang_info.pre_group==1||chufang_info.pre_group==2||chufang_info.pre_group==3||chufang_info.pre_group==4"
          >
            <div
              class="item"
              v-for="(item, index) in drugs_list"
              :key="index"
            >
              <span>{{ item.generic_name }}</span>
              <span>
                <span>{{ item.item_use_level }}g</span>
                <span v-if="item.requirement">({{ item.requirement }})</span>
              </span>
            </div>
          </div>
          <!-- 颗粒饮片的服用方式 -->
          <div
            v-if="drugs_list.length > 0&&(chufang_info.pre_group==1||chufang_info.pre_group==2)"
            style="color: #747981"
          >
            <span
              v-if="chufang_info.drug_machining == 1"
              style="margin-right: 40px"
            >代煎</span>
            <span
              v-if="chufang_info.use_type == 1"
              style="margin-right: 20px"
            >内服</span>
            <span
              v-if="chufang_info.use_type == 2"
              style="margin-right: 20px"
            >外用</span>
            共
            <span style="font-weight;600">{{ chufang_info.total_num }} 剂，每日 1 剂，每剂</span>分
            <span
              style="font-weight;600"
              v-if="chufang_info.use_type == 1"
            >{{ chufang_info.day_num }} 次服用</span>
            <span
              style="font-weight;600"
              v-if="chufang_info.use_type == 2"
            >{{ chufang_info.day_num }} 次使用</span>
          </div>
          <!-- 膏方的服用方式 -->
          <div v-if="chufang_info.pre_group==3">
            <div>
              <span>膏方辅料</span>
              <span style="margin-left:20px">{{ chufang_info.material_name }}</span>
            </div>
            <div style="margin:5px 0">
              <span>包装方式</span>
              <span style="margin-left:17px">
                <span v-if="chufang_info.packing_method==1">
                  瓶装
                </span>
                <span v-if="chufang_info.packing_method==2">
                  袋装
                </span>
                <span>({{ chufang_info.packing_capacity }}ml)</span>
              </span>
            </div>
            <div>
              <span>服用频次</span>
              <span style="margin-left:20px">
                <span>每日{{ chufang_info.day_num }}次，</span>
                <span>
                  <span v-if="chufang_info.packing_method==1">
                    每次{{ chufang_info.times_capacity }}ml
                  </span>
                  <span v-if="chufang_info.packing_method==2">
                    每次{{ chufang_info.times_capacity }}袋
                  </span>
                </span>
              </span>
            </div>
          </div>
          <!-- 丸剂的服用方式 -->
          <div v-if="chufang_info.pre_group==4">
            <span>服用频次</span>
            <span style="margin-left:20px">
              <span>每日{{ chufang_info.day_num }}次，</span>
              <span>每次{{ chufang_info.times_capacity }}g</span>
            </span>
          </div>
          <!-- 养生膏方 -->
          <div
            class="itembox"
            v-if="chufang_info.pre_group == 0"
          >
            <div
              v-for="(item, index) in oil_item_list"
              :key="index"
            >
              <span>{{ item.oil_name }}</span>
              <span>
                <span style="padding: 0 8px">{{ item.item_use_level }} {{ item.oil_spec }}</span>
                <span style="padding: 0 8px">{{ item.oil_unit }}</span>
              </span>
            </div>
          </div>
          <!-- 成药 -->
          <div
            class="itembox"
            v-if="chufang_info.pre_group == -1"
          >
            <div
              v-for="(item, index) in pm_list"
              :key="index"
            >
              <span>{{ item.pm_name }}</span>
              <span>
                <span style="padding: 0 8px">{{ item.item_use_level }} {{ item.pm_spec }}</span>
                <span style="padding: 0 8px"> {{ item.productor }} </span>
                <span style="padding: 0 4px"> {{ item.pm_unit }} </span>
              </span>
            </div>
          </div>
        </div>
        <!-- 医嘱 -->
        <div
          class="dorder-divider"
          style="padding-bottom:10px"
        >
          <div class="title">医嘱</div>
          <div>
            <div>
              <span>用法：</span>
              <span>{{ chufang_info.use_method }}</span>
            </div>
            <div style="margin: 14px 0">
              <span>禁忌：</span>
              <span>{{ chufang_info.taboo }}</span>
            </div>
            <div>
              <span>特殊说明：</span>
              <span>{{ chufang_info.doctor_advice }}</span>
            </div>
          </div>
        </div>
        <!-- 费用明细 -->
        <div class="cost-chufang_info">
          <div class="title">费用明细</div>
          <div style="color: #000">
            <div>
              <span v-if=" chufang_info.pre_group==1">中药材：</span>
              <span v-if=" chufang_info.pre_group==2">中药材：</span>
              <span v-if=" chufang_info.pre_group==3">中药材：</span>
              <span v-if=" chufang_info.pre_group==4">中药材：</span>
              <span v-if=" chufang_info.pre_group==0">养生膏方：</span>
              <span v-if=" chufang_info.pre_group==-1">成药：</span>
              <span class="cost-content">{{ chufang_info.drug_price }}</span>
              <span> 元</span>
            </div>
            <div
              v-if="chufang_info.pre_group==3"
              style="margin-top: 14px"
            >
              <span class="cost-title">辅料费：</span>
              <span class="cost-content">{{ chufang_info.excipients_price }}</span>
              <span> 元</span>
            </div>
            <div
              style="margin-top: 14px"
              v-if="chufang_info.drug_machining_price"
            >
              <span class="cost-title">加工费：</span>
              <span class="cost-content">{{
                chufang_info.drug_machining_price
              }}</span>
              <span> 元</span>
            </div>
            <div style="margin-top: 14px">
              <span class="cost-title">诊后管理费(与药费合并，不单独显示)：</span>
              <span class="cost-content">{{ chufang_info.consult_drug_price }}</span>
              <span> 元</span>
            </div>
            <div style="margin: 14px 0">
              <span class="cost-title">诊金(与药费合并，不单独显示)：</span>
              <span class="cost-content">{{ chufang_info.consulting_gold }}</span>
              <span> 元</span>
            </div>
            <div>
              <span class="cost-title">总计：</span>
              <span class="cost-content">{{ chufang_info.total_price }}</span>
              <span> 元</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="page_title flex_between">
      <span>问诊记录详情</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="info">
          <div class="inbobox">
            <div class="inboitem">
              <div class="infotitle">用户昵称：</div>
              <div>{{ user_info.nick_name }}</div>
            </div>
            <div class="inboitem">
              <div class="infotitle">性别：</div>
              <div v-if="user_info.sex == 1">男</div>
              <div v-if="user_info.sex == 2">女</div>
              <div v-if="user_info.sex == 0">未知</div>
            </div>
            <div class="inboitem">
              <div class="infotitle">手机号：</div>
              <div>{{ user_info.phone }}</div>
            </div>
          </div>
          <div
            class="inbobox"
            style="margin: 0 20px"
          >
            <div class="inboitem">
              <div class="infotitle">患者姓名：</div>
              <div>{{ patient_info.real_name }}</div>
            </div>
            <div class="inboitem">
              <div class="infotitle">性别：</div>
              <div v-if="patient_info.sex == 1">男</div>
              <div v-if="patient_info.sex == 2">女</div>
              <div v-if="patient_info.sex == 0">未知</div>
            </div>
            <div class="inboitem">
              <div class="infotitle">年龄：</div>
              <div>{{ patient_info.age }}</div>
            </div>
          </div>
          <div class="inbobox">
            <div class="inboitem">
              <div class="infotitle">医生姓名：</div>
              <div
                @click="showDocMsg(doctor_info.doctor_id)"
                style="cursor:pointer"
              >{{ doctor_info.doctor_name }}</div>
            </div>
            <div class="inboitem">
              <div class="infotitle">性别：</div>
              <div v-if="doctor_info.sex == 1">男</div>
              <div v-if="doctor_info.sex == 2">女</div>
              <div v-if="doctor_info.sex == 0">未知</div>
            </div>
            <div class="inboitem">
              <div class="infotitle">手机号：</div>
              <div>{{ doctor_info.phone }}</div>
            </div>
          </div>
        </div>

        <!-- 原始记录列表 -->
        <div
          style="margin: 20px 0"
          class="littletitle"
        >原始记录</div>
        <div v-if="!group_id || group_id == 0||!log_list.length">
          暂无记录
        </div>
        <template>
          <!-- 正常流程 -->
          <div
            v-for="(item, index) in log_list"
            :key="index"
          >
            <div
              v-if="item.ext"
              class="log"
            >
              <div>
                <span
                  class="gray"
                  v-if="item.user_type == 1"
                >医生：{{ item.user_name }}</span>
                <span
                  class="gray"
                  v-if="item.user_type == 2"
                >用户：{{ item.user_name }}</span>
                <span
                  class="gray"
                  v-if="item.user_type == 3"
                >系统</span>
              </div>
              <div class="loginfo">
                <!-- 病情自述 -->
                <div
                  class="green infotxt"
                  @click="openbingqing"
                  v-if="item.type == 'txt' && item.ext.type == 2"
                >
                  【病情自述】
                </div>
                <!-- 问诊单 -->
                <div
                  class="green infotxt"
                  @click="
                    openwenzhen(item.ext.inquiry_sheet_id, item.ext.unique_key)
                  "
                  v-if="item.type == 'txt' && item.ext.type == 3"
                >
                  【问诊单】
                </div>
                <!-- 处方建议 -->
                <div
                  class="green infotxt"
                  @click="openwenchufang(item.ext.pre_id)"
                  v-if="item.type == 'txt' && item.ext.type == 4"
                >
                  【处方建议】
                </div>
                <!-- 文字信息 -->
                <div
                  v-if="
                    item.type == 'txt' &&
                    item.bodies.type == 'txt' &&
                    (!item.ext.type ||
                      item.ext.type == 1 ||
                      item.ext.type == '0' ||
                      item.ext.type == '11'||
                      item.ext.type == '12'||
                      item.ext.type == '14'||
                      item.ext.type == '15'||
                      item.ext.type == '16')
                  "
                  class="infotxt"
                >
                  {{
                    item.bodies.msg? item.bodies.msg: item.ext.doctor_msg? item.ext.doctor_msg: item.ext.patient_msg
                  }}
                </div>
                <!-- 体检推荐 -->
                <div
                  v-if="
                    item.type == 'txt' &&
                    item.bodies.type == 'txt' &&
                    item.ext.type == '6'
                  "
                  class="infotxt"
                >
                  {{ item.ext.doctor_msg }}
                </div>
                <!-- 患教文章 -->
                <div
                  v-if="
                    item.type == 'txt' &&
                    item.bodies.type == 'txt' &&
                    item.ext.type == '5'
                  "
                  class="infotxt"
                >
                  【患教文章】
                </div>
                <!-- 语音信息 -->
                <div
                  v-if="item.type == 'audio'"
                  class="green infotxt"
                  @click="uploadAudio(item.bodies.url)"
                >
                  【语音消息】
                </div>
                <!-- 电话语音 -->
                <div
                  v-if="item.ext.duration&&item.ext.type=='10'"
                  class="green infotxt"
                >
                  <audio
                    :src="item.ext.record_url"
                    controls
                  >
                    【您的浏览器不支持播放语音】
                  </audio>
                </div>
                <!-- 图片信息 -->
                <div v-if="item.type == 'img'">
                  <img
                    :src="item.bodies.local_url"
                    alt
                    style="width: 200px; cursor: pointer"
                    @click="toimgPre(item.bodies.local_url)"
                  />
                </div>
                <div
                  class="gray"
                  style="width: 200px; text-align: right"
                >
                  {{ item.timestamp }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="consult_types == 2">
          <!-- 视频问诊  -->
          <div
            v-for="(item, index) in videoList"
            :key="index"
            class="videoList"
          >
            <!-- 处方建议 -->
            <div
              class="info bb felx align-center between"
              v-if="item.msg_type == 3"
              @click="openwenchufang(item.ext.pre_id)"
            >
              <div class="text green">【处方建议】</div>
              <div class="time">{{ formartTime(item.create_time) }}</div>
            </div>
            <!-- 文本消息 -->
            <div
              class="info bb felx align-center between"
              v-if="item.msg_type == 1 || item.msg_type == 4"
            >
              <div class="text">{{ item.doctor_msg }}</div>
              <div class="time">{{ formartTime(item.create_time) }}</div>
            </div>
            <!-- 视频消息 -->
            <div
              class="info bb felx align-center between"
              v-if="item.msg_type == 2"
            >
              <div>
                <div v-if="item.ext.status == 0">医生发起视频</div>
                <div v-if="item.ext.status == 1">视频通话中</div>
                <div v-if="item.ext.status == 2">医生挂断视频</div>
                <div v-if="item.ext.status == 3">患者挂断视频</div>
                <div v-if="item.ext.status == 4">医生异常挂断视频</div>
                <div v-if="item.ext.status == 5">患者异常挂断视频</div>
                <div v-if="item.ext.status == 6">未接通视频</div>
                <div v-if="item.ext.status == 7">患者拒接视频</div>
                <div v-if="item.ext.start_time">
                  开始时间： {{ formartTime(item.ext.start_time) }}
                </div>
                <div v-if="item.ext.end_time">
                  结束时间： {{ formartTime(item.ext.end_time) }}
                </div>
                <div v-if="item.ext.start_time && item.ext.end_time">
                  问诊时长：
                  {{ computedTime(item.ext.start_time, item.ext.end_time) }}
                </div>
              </div>
              <div class="time">{{ formartTime(item.create_time) }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import yewu from '../../../api/yewu';
import platform from '../../../api/platform';
import dayjs from 'dayjs';
import DocMsg from '../../../components/common/DocMsg.vue';
let relativeTime = require('dayjs/plugin/relativeTime');
dayjs.extend(relativeTime);
export default {
  data() {
    return {
      consult_types: this.$route.query.consult_types, // 当为4时是视频问诊 需要调用不用的历史记录接口
      bingqing: false,
      wenzhendan: false,
      chufang: false,
      user_info: {},
      patient_info: {},
      doctor_info: {},
      bingqing_info: {
        tongue_img: [],
        face_img: [],
        history_img: []
      },
      group_id: '',
      wenzhen_info: [],
      chufang_info: {},
      drugs_list: [],
      imgPre: '',
      img_pre: false,
      log_list: [],
      videoList: [], //视频问诊记录
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    Url() {
      // return document.location.protocol + "//" + window.location.host + "/";
      let host = window.location.host;
      if (
        host.indexOf('qp.xlanben.com') != -1 ||
        host.indexOf('localhost') != -1
      ) {
        return 'https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/';
      } else {
        return 'https://qhyg-prd-1258702188.cos.ap-chengdu.myqcloud.com/';
      }
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //问诊记录详情
    getDetail() {
      let consult_id = this.$route.query.consult_id;
      let fn =
        this.$route.query.isPush == 1 ? 'consultUploadItem' : 'consultItem';
      yewu[fn]({ consult_id })
        .then((res) => {
          if (res.code == 0) {
            this.user_info = res.data.user_info;
            this.patient_info = res.data.patient_info;
            this.doctor_info = res.data.doctor_info;
            this.group_id = res.data.consult_info.group_id;
            if (this.consult_types == 2) {
              this.getVideoConsultMsgList();
              return false;
            }
            if (res.data.consult_info.group_id) {
              this.getLogList(res.data.consult_info.group_id);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取病情自述详情
    getBingqing() {
      let consult_id = this.$route.query.consult_id;
      yewu
        .complainItem({ consult_id })
        .then((res) => {
          if (res.code == 0) {
            this.bingqing_info = res.data.info;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取问诊单详情
    getWenzhen(inquiry_sheet_id, unique_key) {
      yewu.inquiryItem({ inquiry_sheet_id, unique_key }).then((res) => {
        if (res.code == 0) {
          this.wenzhen_info = res.data.info.content;
        }
      });
    },
    //获取处方详情
    getChufang(pre_id) {
      yewu.prescriptionItem({ pre_id }).then((res) => {
        if (res.code == 0) {
          this.chufang_info = res.data.info;
          this.drugs_list = res.data.info.item_list;
          this.chufang_info.create_time = platform.timestampToTime(
            this.chufang_info.create_time
          );
        }
      });
    },
    //获取原始记录列表
    getLogList(group_id) {
      yewu
        .getMsgList({ group_id })
        .then((res) => {
          if (res.code == 0) {
            this.log_list = res.data.list.map((item) => {
              item.timestamp = platform.timestampToTime(item.timestamp);
              return item;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formartTime(time) {
      return platform.timestampToTime(time);
    },
    //病情自述预览
    openbingqing() {
      this.getBingqing();
      this.bingqing = true;
    },
    //问诊单预览
    openwenzhen(inquiry_sheet_id, unique_key) {
      this.getWenzhen(inquiry_sheet_id, unique_key);
      this.wenzhendan = true;
    },
    //处方建议预览
    openwenchufang(pre_id) {
      this.getChufang(pre_id);
      this.chufang = true;
    },
    //下载语音消息
    uploadAudio(url) {
      location.href = url;
    },
    //图片放大预览
    toimgPre(img_str) {
      this.img_pre = true;
      this.imgPre = img_str;
    },

    back() {
      history.back();
    },
    //获取视频问诊
    getVideoConsultMsgList() {
      let data = {
        consult_id: this.$route.query.consult_id
      };
      this.axios
        .post('platform/consult/getVideoConsultMsgList', data)
        .then((res) => {
          this.videoList = res.data.list;
          // console.log(this.videoList);
        });
    },
    computedTime(start_time, end_time) {
      let date1 = dayjs.unix(start_time);
      let date2 = dayjs.unix(end_time);
      let second = date2.diff(date1, 'second');
      let minute = Math.floor(second / 60);
      return minute + '分' + second + '秒';
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  border-radius: 5px;
  text-align: left;
}
.info {
  display: flex;
  .inbobox {
    padding: 14px 0 2px 20px;
    box-sizing: border-box;
    background-color: #f9f8ee;
    border: solid 1px #dad8ca;
    width: 260px;
    height: 112px;
    .inboitem {
      display: flex;
      margin-bottom: 12px;
      .infotitle {
        width: 80px;
      }
    }
  }
}
.gray {
  color: #747981;
}
.green {
  color: #669961;
  cursor: pointer;
}
.log {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #e1e3e9;
  margin-bottom: 14px;
  .loginfo {
    // width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
    .infotxt {
      width: 87%;
      word-wrap: break-word;
    }
  }
}
.littletitle {
  font-size: 16px;
  font-weight: 600;
}
.myimg {
  width: 120px;
  height: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
.wenzhentitle {
  line-height: 24px;
  font-weight: 600;
}
.wenzhencontent {
  color: #669961;
  line-height: 20px;
  padding-left: 10px;
}

.chufangdia {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 5px;
  text-align: left;
  .inbobox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    .inboitem {
      padding: 14px 50px 14px 20px;
      box-sizing: border-box;
      background-color: #f9f8ee;
      border: solid 1px #dad8ca;
      .infotitle {
        width: 90px;
        display: inline-block;
      }
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 14px;
  }
  .itembox {
    display: flex;
    color: #000;
    flex-wrap: wrap;
    .item {
      width: 180px;
      display: flex;
      justify-content: space-between;
      margin-right: 40px;
      position: relative;
      margin-bottom: 22px;
    }
    .item::before {
      content: '';
      position: absolute;
      height: 12px;
      width: 1px;
      background: #d7d7d7;
      left: 200px;
      top: 4px;
    }
  }
}
.videoList {
  .info {
    // background-color: #cccccc;
    border: solid 1px #e1e3e9;

    padding: 10px;
    margin-bottom: 10px;
    div {
      line-height: 25px;
    }
    .time {
      margin-left: 30px;
    }
  }
}
</style>